import type { ReportWidgetColorPalette } from '../model/types';

// Neutral (default) blue palette.
export const BLUE_PALETTE = [
    'hsl(221, 83%, 53%)',
    'hsl(221, 75%, 60%)',
    'hsl(221, 65%, 67%)',
    'hsl(221, 55%, 74%)',
    'hsl(221, 45%, 80%)',
];

// Green palette for savings (positive).
export const GREEN_PALETTE = [
    'hsl(142, 76%, 36%)',
    'hsl(142, 69%, 45%)',
    'hsl(142, 60%, 52%)',
    'hsl(142, 52%, 60%)',
    'hsl(142, 45%, 68%)',
    'hsl(142, 70%, 40%)',
    'hsl(142, 62%, 48%)',
    'hsl(142, 54%, 56%)',
];

// Orange/amber palette for missed savings (negative).
export const AMBER_PALETTE = [
    'hsl(25, 95%, 53%)',
    'hsl(32, 95%, 55%)',
    'hsl(38, 92%, 58%)',
    'hsl(45, 90%, 62%)',
    'hsl(50, 88%, 65%)',
];

const DEFAULT_COLORS = BLUE_PALETTE;

interface GetChartColorsArgs {
    palette?: ReportWidgetColorPalette;
    colors?: string[];
}

export const getChartColors = ({
    palette,
    colors,
}: GetChartColorsArgs): string[] => {
    if (colors && colors.length > 0) {
        return colors;
    }

    if (palette === 'positive') {
        return GREEN_PALETTE;
    }

    if (palette === 'negative') {
        return AMBER_PALETTE;
    }

    return DEFAULT_COLORS;
};
